/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcdms.vcdoctype')
    .component('doctypeform', {
      restrict: 'E',
      bindings: {
        doctype: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcdms/doctype/doctypeform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Printerlist',
        function ($log, Printerlist) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;

          vm.$onInit = function () {
            vm.lastdoctype = angular.copy(vm.doctype);
            vm.allprinters = Printerlist.getPrinters();
          };
          
          function save() {
            if (!angular.equals(vm.doctype, vm.lastdoctype)) {
              vm.lastdoctype = angular.copy(vm.doctype);
              vm.parentsave({doctype: vm.doctype});
            }
          }
          
          function cancel() {
            vm.doctype = angular.copy(vm.lastdoctype);
            vm.oncancel();
          }

        }] // controller
    }); // component

// klammerfriedhof
}());
